module.exports = __webpack_public_path__ + "static/58invgde-46afaedf5781b0bbd5fa750aad4e466b.gif";